import { Component } from '@angular/core';
import { BlockAbstractComponent } from '@gallaghercp/core-frontend';

@Component({
    selector: 'core-block-testimonial',
    templateUrl: './block-testimonial.component.html',
    styleUrl: './block-testimonial.component.scss',
    standalone: false,
})
export class BlockTestimonialComponent extends BlockAbstractComponent {}
